// src/App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // needed for navbar toggler collapse
import './styles/variables.css';
import './styles/custom.css';

import Navbar         from './components/Navbar';
import Footer         from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Home           from './pages/Home';

// Keyframes injected globally for floating cards and fade-in animations
const globalKeyframes = `
  @keyframes floatY {
    0%, 100% { transform: translateY(0px); }
    50%       { transform: translateY(-10px); }
  }
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  /* Navbar hover color */
  nav ul li a:hover {
    color: #5A9E4B !important;
  }
  /* Footer link hover */
  footer a:hover, footer span[style*="cursor"]:hover {
    color: #5A9E4B !important;
  }
  /* Social icon hover in footer */
  footer a[aria-label]:hover {
    background-color: rgba(255,255,255,0.18) !important;
    transform: scale(1.1);
  }
  /* Focus states for accessibility */
  *:focus-visible {
    outline: 3px solid #5A9E4B;
    outline-offset: 3px;
  }
  /* Mobile: hide desktop nav */
  @media (max-width: 768px) {
    nav > div > ul { display: none !important; }
    nav > div > a.btn-viha-primary { display: none !important; }
    nav > div > button { display: flex !important; }
  }
`;

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-cubic',
      offset: 60,
    });

    // Inject global keyframes
    const style = document.createElement('style');
    style.textContent = globalKeyframes;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Additional pages can be added here:
            <Route path="/about"    element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact"  element={<ContactPage />} />
        */}
      </Routes>
      <Footer />
      <FloatingWhatsApp phoneNumber="91XXXXXXXXXX" />
    </Router>
  );
};

export default App;